export const CPM_WARN_MS = 120_000;
export const CPM_COUNTDOWN_MS = 30_000;
export const CPM_HOLD_MS = 30_000;
export const CPM_BILL_INTERVAL_MS = 60_000;
export function estimateCpmRemainingMs(input) {
    const rate = input.coinsPerMinute;
    if (rate <= 0) {
        return Number.POSITIVE_INFINITY;
    }
    const now = input.now ?? Date.now();
    const lastBilled = input.lastBilledAt ? Date.parse(input.lastBilledAt) : Number.NaN;
    const elapsed = Number.isFinite(lastBilled) ? Math.max(0, now - lastBilled) : 0;
    const untilNextTick = Math.max(0, CPM_BILL_INTERVAL_MS - elapsed);
    const extraMs = Math.floor(Math.max(0, input.balanceCoins) / rate) * CPM_BILL_INTERVAL_MS;
    return untilNextTick + extraMs;
}
export function holdRemainingMs(holdUntil, now = Date.now()) {
    if (!holdUntil) {
        return 0;
    }
    const until = Date.parse(holdUntil);
    if (!Number.isFinite(until)) {
        return 0;
    }
    return Math.max(0, until - now);
}
export function resolveCpmRunwayPhase(input) {
    if (holdRemainingMs(input.holdUntil, input.now) > 0) {
        return 'hold';
    }
    if (input.remainingMs <= 0) {
        return 'hold';
    }
    if (input.remainingMs <= CPM_COUNTDOWN_MS) {
        return 'countdown';
    }
    if (input.remainingMs <= CPM_WARN_MS) {
        return 'warn';
    }
    return 'ok';
}
export function formatCpmCountdown(ms) {
    const totalSeconds = Math.max(0, Math.ceil(ms / 1000));
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}
//# sourceMappingURL=cpm-runway.js.map